import {QUESTION_TYPE} from '../elements/question.type.model';

/**
 * Questions sur lesquelles une condition d'affichage peut porter : celles dont les réponses
 * s'énumèrent, et elles seules.
 *
 * Une réponse libre — commentaire, texte court, texte long — ne se compare à rien de prédéfini : il
 * n'y aurait aucune valeur à proposer en face de l'opérateur. Une zone de texte ou un lien vers un
 * site d'avis n'attendent, eux, aucune réponse.
 */
export const CONDITION_QUESTION_TYPES: QUESTION_TYPE[] = [
    QUESTION_TYPE.NPS,
    QUESTION_TYPE.CSAT,
    QUESTION_TYPE.MONO_CSAT,
    QUESTION_TYPE.MULTI_CSAT,
    QUESTION_TYPE.CES,
    QUESTION_TYPE.SCALE,
    QUESTION_TYPE.CHOICES,
];
